module.exports = __webpack_public_path__ + "img/sumseikr_40_60.5293b3ea.jpg";